import React, { useEffect } from "react";
import styled from "styled-components";

const jigsawReaderId = "reader";

const ReaderContainer = styled.div.attrs({
  id: jigsawReaderId,
})`
  height: 100%;
  width: 100%;
`;

export interface ReaderProps
  extends Pick<
    jigsaw.CreatePageViewerConfig,
    "vbid" | "start" | "end" | "url"
  > {
  onViewerReady?: (v: jigsaw.Viewer, d: jigsaw.BookData) => void;
  onViewerError?: () => void;
}

const BaseReader = ({
  vbid,
  onViewerReady,
  onViewerError,
  start,
  end,
  url,
}: ReaderProps) => {
  useEffect(() => {
    const viewer: jigsaw.Viewer = window.Jigsaw.createPageViewer(
      {
        vbid,
        highlightsEnabled: true,
        swipeDisabled: true,
        autofocus: false,
        el: jigsawReaderId,
        zoomDisabled: true,
        noteIcon: { svgIcon: true },
        start,
        end,
        url,
      },
      result => {
        if (result.isSuccess()) {
          if (onViewerReady) {
            onViewerReady(viewer, result.data);
          }
        } else {
          if (onViewerError) {
            onViewerError();
          }
        }
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <ReaderContainer />;
};

export default BaseReader;
